
//const Url = 'https://localhost:7239/';
const Url ='https://boxonresourceservice.boxonlogistics.com/';
const BasePath = 'https://resource.boxonlogistics.com/VideoTutorial/resources';

export {BasePath,Url}
// export  default Url

// const getBaseUrl = () => { 
//     let url;
//     switch(process.env.NODE_ENV) {
//         case 'production':
//             url = 'https://noptest.boxonlogistics.com/';
//             BasePath = 'https://resource.smarteweb.com/VideoTutorial/resources';
//             break;
//              case 'development':
//                 default: 
//                 url = 'https://localhost:7239/';
//                 BasePath = 'https://resource.smarteweb.com/VideoTutorial/resources'; }
//                 return url; 
// }

// export default axios.create({ 
//     baseURL: getBaseUrl(), });
